module.exports = __webpack_public_path__ + "img/christine-sinclair.966298c5.png";